export default __webpack_public_path__ + "static/media/logo-tts-vi-v3.a7837b55.svg";